import { render, staticRenderFns } from "./AgentList.vue?vue&type=template&id=5235911e&scoped=true&"
import script from "./AgentList.vue?vue&type=script&lang=js&"
export * from "./AgentList.vue?vue&type=script&lang=js&"
import style0 from "./AgentList.vue?vue&type=style&index=0&id=5235911e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235911e",
  null
  
)

export default component.exports